export const handleFolderScopeModeChange = target => {
    const container = target.closest('[data-folder-scope]');

    if (!container) {
        return;
    }

    const folders = container.querySelector('[data-folder-scope-folders]');

    if (!folders) {
        return;
    }

    folders.hidden = target.value !== 'specific';

    if (!folders.hidden) {
        window.scrollTo({top: document.documentElement.scrollHeight, behavior: 'smooth'});
    }
};
